import { barChartItem } from './barChart';



export const languagesChartItems: barChartItem[] = [
    {
      itemName: 'PHP',
      itemPercentage: 80
    },
    {
      itemName: 'TypeScript',
      itemPercentage: 70
    },
    {
      itemName: 'JavaScript',
      itemPercentage: 70
    },
    {
      itemName: 'Shell',
      itemPercentage: 70
    },
    {
      itemName: 'Python',
      itemPercentage: 60
    },
    {
      itemName: 'Java',
      itemPercentage: 60
    },
    {
      itemName: 'Go',
      itemPercentage: 50
    },
  ];
